// COMPANY NAME
const company_name = "TOPUP CONNECT";

//const url = "https://" + window.location.hostname + "/";

//const url = "http://192.168.1.8:5050/";

const url = "https://app.topupconnect.in/";

const app_url = "https://www.topupconnect.in/";

exports.getCurrentDate = (separator = "-") => {
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${year}${separator}${
    month < 10 ? `0${month}` : `${month}`
  }${separator}${date < 10 ? `0${date}` : date}`;
};

exports.capitalize = (str) => {
  const arrOfWords = str.split(" ");
  const arrOfWordsCased = [];

  for (let i = 0; i < arrOfWords.length; i++) {
    const word = arrOfWords[i];
    arrOfWordsCased.push(word[0].toUpperCase() + word.slice(1).toLowerCase());
  }

  return arrOfWordsCased.join(" ");
};

exports.IsJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const states = [
  { value: "ANDHRA PRADESH", label: "ANDHRA PRADESH" },
  { value: "ARUNACHAL PRADESH", label: "ARUNACHAL PRADESH" },
  { value: "ASSAM", label: "ASSAM" },
  { value: "BIHAR", label: "BIHAR" },
  { value: "CHHATTISGARH", label: "CHHATTISGARH" },
  { value: "GOA", label: "GOA" },
  { value: "GUJARAT", label: "GUJARAT" },
  { value: "HARYANA", label: "HARYANA" },
  { value: "HIMACHAL PRADESH", label: "HIMACHAL PRADESH" },
  { value: "JHARKHAND", label: "JHARKHAND" },
  { value: "KARNATAKA", label: "KARNATAKA" },
  { value: "KERALA", label: "KERALA" },
  { value: "MADHYA PRADESH", label: "MADHYA PRADESH" },
  { value: "MAHARASHTRA", label: "MAHARASHTRA" },
  { value: "MANIPUR", label: "MANIPUR" },
  { value: "MEGHALAYA", label: "MEGHALAYA" },
  { value: "MIZORAM", label: "MIZORAM" },
  { value: "NAGALAND", label: "NAGALAND" },
  { value: "ODISHA", label: "ODISHA" },
  { value: "PUNJAB", label: "PUNJAB" },
  { value: "RAJASTHAN", label: "RAJASTHAN" },
  { value: "SIKKIM", label: "SIKKIM" },
  { value: "TAMIL NADU", label: "TAMIL NADU" },
  { value: "TELANGANA", label: "TELANGANA" },
  { value: "TRIPURA", label: "TRIPURA" },
  { value: "UTTAR PRADESH", label: "UTTAR PRADESH" },
  { value: "UTTARAKHAND", label: "UTTARAKHAND" },
  { value: "WEST BENGAL", label: "WEST BENGAL" },

  {
    value: "ANDAMAN AND NICOBAR ISLANDS",
    label: "ANDAMAN AND NICOBAR ISLANDS",
  },
  { value: "CHANDIGARH", label: "CHANDIGARH" },
  {
    value: "DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
    label: "DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
  },
  { value: "DELHI", label: "DELHI" },
  { value: "JAMMU AND KASHMIR", label: "JAMMU AND KASHMIR" },
  { value: "LADAKH", label: "LADAKH" },
  { value: "LAKSHADWEEP", label: "LAKSHADWEEP" },
  { value: "PUDUCHERRY", label: "PUDUCHERRY" },
];

exports.companyName = company_name;
exports.baseUrl = url;
exports.appUrl = app_url;
exports.states = states;
